// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

// NGX
import { QuillModule } from "ngx-quill";

// BBWT
import { CompanyDetailsComponent } from "./company-details.component";
import { CompaniesComponent } from "./companies.component";
import { GridModule } from "@features/grid";
import { BbCardModule } from "@features/bb-card";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { SquadModule } from "@project/squad/squad.module";
import { CompanyRoutingModule } from "./companies-routing.module";
import { PlayerModule } from "@project/player/player.module";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { EnabledModuleControlComponent } from "./enabled-module-control.component";
import { FilterModule } from "@features/filter";
import { AccessDirectivesModule } from "@main/access-directives/access-directives.module";
import { FormIOModuleService } from "@main/formio/services/formio-module.service";
import { FormEventsService } from "@main/formio/services/formEvents.service";
import { FormEventsModule } from "@main/formio/components/form-events/form-events.module";
import { DividerModule } from "primeng/divider";


@NgModule({
    declarations: [CompanyDetailsComponent, CompaniesComponent, EnabledModuleControlComponent],
    providers: [FormIOModuleService, FormEventsService] ,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimeNgModule,
        QuillModule,
        // BBWT
        BbwtSharedModule,
        GridModule,
        BbCardModule,

        CompanyRoutingModule,
        MiproSharedModule,
        SquadModule,
        PlayerModule,
        FilterModule,
        AccessDirectivesModule,
        FormEventsModule,
        DividerModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CompaniesModule {}
